import { PermissionGuard } from '@/app/auth/guards/permission.guard';
import { inject } from '@angular/core';
import { Route } from '@angular/router';

export const CsiRoutes: Route = {
    path: 'csi',
    data: { title: 'csi' },
    children: [
        {
            path: '',
            pathMatch: 'full',
            redirectTo: 'contracts',
        },
        {
            path: 'contracts',
            loadComponent: () => import('./csi-contract/csi-contract.component').then((m) => m.CsiContractComponent),
            data: { title: 'csi_contract' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'subcontract',
            loadComponent: () => import('./subcontract/subcontract.component').then((m) => m.SubcontractComponent),
            data: { title: 'subcontract' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'subcontract-asset',
            loadComponent: () =>
                import('./subcontract-asset/subcontract-asset.component').then((m) => m.SubcontractAssetComponent),
            data: { title: 'subcontract-asset' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'subcontract-city',
            loadComponent: () =>
                import('./subcontract-city/subcontract-city.component').then((m) => m.SubcontractCityComponent),
            data: { title: 'subcontract-city' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'subcontract-country',
            loadComponent: () =>
                import('./subcontract-country/subcontract-country.component').then(
                    (m) => m.SubcontractCountryComponent
                ),
            data: { title: 'subcontract-country' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'subcontract-impact-area',
            loadComponent: () =>
                import('./subcontract-impact-area-mapping/subcontract-impact-area-mapping.component').then(
                    (m) => m.SubcontractImpactAreaMappingComponent
                ),
            data: { title: 'subcontract-impact-area' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'subcontract-milestone',
            loadComponent: () =>
                import('./subcontract-milestone/subcontract-milestone.component').then(
                    (m) => m.SubcontractMilestoneComponent
                ),
            data: { title: 'subcontract-milestone' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'subcontract-property',
            loadComponent: () =>
                import('./subcontract-property/subcontract-property.component').then(
                    (m) => m.SubcontractPropertyComponent
                ),
            data: { title: 'subcontract-property' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'subcontract-property-mapping',
            loadComponent: () =>
                import('./subcontract-property-mapping/subcontract-property-mapping.component').then(
                    (m) => m.SubcontractPropertyMappingComponent
                ),
            data: { title: 'subcontract-property-mapping' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'subcontract-property-entry',
            loadComponent: () =>
                import('@/app/pages/csi/subcontract-property-entry/subcontract-property-entry.component').then(
                    (m) => m.SubcontractPropertyEntryComponent
                ),
            data: { title: 'subcontract-property-entry' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'subcontract-property-type',
            loadComponent: () =>
                import('./subcontract-property-type/subcontract-property-type.component').then(
                    (m) => m.SubcontractPropertyTypeComponent
                ),
            data: { title: 'subcontract-property-type' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'subcontract-property-unit',
            loadComponent: () =>
                import('./subcontract-property-unit/subcontract-property-unit.component').then(
                    (m) => m.SubcontractPropertyUnitComponent
                ),
            data: { title: 'subcontract-property-unit' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'baseline-farmers',
            loadComponent: () =>
                import('./baseline-farmers/baseline-farmers.component').then((m) => m.BaselineFarmersComponent),
            data: { title: 'baseline-farmers' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        {
            path: 'baseline-farms',
            children: [
                {
                    path: '',
                    loadComponent: () =>
                        import('./baseline-farms/baseline-farms.component').then((m) => m.BaselineFarmsComponent),
                    data: { title: 'baseline-farms' },
                    // canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
                },
                {
                    path: 'form',
                    loadComponent: () =>
                        import('./baseline-farms/baseline-farm-form/baseline-farm-form.component').then(
                            (m) => m.BaselineFarmFormComponent,
                        ),
                    data: { title: 'baseline-farm-form' },
                },
                {
                    path: 'form/:id',
                    loadComponent: () =>
                        import('./baseline-farms/baseline-farm-form/baseline-farm-form.component').then(
                            (m) => m.BaselineFarmFormComponent,
                        ),
                    data: { title: 'baseline-farm-form' },
                },
            ],
        },
        {
            path: 'subcontract-baseline-assignment',
            loadComponent: () =>
                import('./subcontract-baseline-assignment/subcontract-baseline-assignment.component').then(
                    (m) => m.SubcontractBaselineAssignmentComponent,
                ),
            data: { title: 'subcontract-baseline-assignment' },
            canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        },
        // {
        //     path: 'subcontract-unit',
        //     loadComponent: () =>
        //         import('./subcontract-unit/subcontract-unit.component').then((m) => m.SubcontractUnitComponent),
        //     data: { title: 'subcontract-unit' },
        //     canActivate: [(route: any, state: any) => inject(PermissionGuard).canActivate(route, state)],
        // },
    ],
};
